



























































import Vue from 'vue';
import Layout from '@/layouts/_BlankCentredLayout.vue';
import { SIGNUP_REQUEST } from '@/use-cases/user-signup/SignUpModule';

export default Vue.extend({
  name: 'SignUp',
  components: {
    Layout,
  },
  data() {
    return {
      name: '',
      email: '',
      password: '',
      error: '',
      success: '',
    };
  },
  computed: {
    isValid(): boolean {
      return !!(this.email && this.password && this.name);
    },
    isLoading(): boolean {
      return this.$store.state.signup.status === 'loading';
    },
  },
  methods: {
    onClickSignUp() {
      const command = {
        name: this.name,
        email: this.email,
        password: this.password,
      };

      this.$store.dispatch(SIGNUP_REQUEST, command)
        .then(() => {
          this.success = 'Sign up successful. Please wait for approval by email. This is a manual process so may take several days.';
        })
        .catch(() => {
          this.error = 'Sign up unsuccessful. Please try again later';
        });
    },
  },
});
